/**
 * Copyright (c) 2026, CheckPlus Limited
 */
const DefaultFormData = () => {
  return [
    {
      id: "projectId",
      paymentKey: "projectId",
      label: "Item",
      placeholder: "Item",
      value: "",
      valueText: "",
      type: "dropdown",
      options: [{
        label: "Select a Project",
        value: "",
      }],
      required: true,
    },
    {
      id: "paymentType",
      paymentKey: "type",
      label: "Payment Type",
      placeholder: "Payment Type",
      value: 'payment',
      type: "dropdown",
      options: [
        {
          label: "Payment",
          value: "payment",
        },
        {
          label: "Donation",
          value: "donation",
        },
      ],
      required: true,
    },
    {
      id: "firstName",
      paymentKey: "donorFirstName",
      label: "First Name",
      placeholder: "First Name",
      value: "",
      type: "text",
      required: true,
    },
    {
      id: "lastName",
      paymentKey: "donorLastName",
      label: "Last Name",
      placeholder: "Last Name",
      value: "",
      type: "text",
      required: true,
    },
    {
      id: "email",
      paymentKey: "donorEmail",
      label: "Email Address",
      placeholder: "Email Address",
      value: "",
      type: "text",
      required: true,
    },
    {
      id: "phone",
      paymentKey: "phoneNumber",
      label: "Phone Number",
      placeholder: "Phone Number",
      value: "",
      type: "phone",
      required: true,
    },
    {
      id: "paymentName",
      paymentKey: "PaymentName",
      label: "Payment Method",
      placeholder: "Payment Method",
      value: "",
      valueText: "",
      type: "dropdown",
      options: [
        {
          label: "FPS",
          value: "fps",
        },
        {
          label: "AlipayHK (Hong Kong)",
          value: "alipay_hk",
        },
        {
          label: "Alipay (China)",
          value: "alipay_ch",
        },
        {
          label: "WeChat Pay HK (Hong Kong)",
          value: "wechatpay_hk",
        },
        {
          label: "WeChat Pay (China)",
          value: "wechatpay_ch",
        },
        {
          label: "BoC Pay",
          value: "bocpay",
        },
        {
          label: "Octopus",
          value: "octopus",
        },
        {
          label: "Bank Transfer",
          value: "bank_transfer",
        },
        {
          label: "Cheque",
          value: "check_writing",
        },
        {
          label: "Cash",
          value: "cash",
        },
        {
          label: "PayPal",
          value: "paypal_manual",
        },
      ],
      required: false,
    },
    {
      id: "status",
      paymentKey: "status",
      label: "Status",
      placeholder: "Status",
      value: "",
      valueText: "",
      type: "dropdown",
      options: [
        {
          label: "Pending",
          value: "pending_for_confirmation",
        },
        {
          label: "Approve",
          value: "complete",
        },
        {
          label: "Decline",
          value: "error",
        },
      ],
      required: true,
    },
    {
      id: "amount",
      paymentKey: "amount",
      label: "Amount",
      placeholder: "Amount",
      value: 0,
      type: "decimal",
      required: true,
    },
    {
      id: "transactionFee",
      paymentKey: "fee",
      label: "Total Fee",
      placeholder: "Total Fee",
      value: 0,
      type: "decimal",
      required: true,
    },
    {
      id: "net",
      paymentKey: "net",
      label: "Net",
      placeholder: "Net",
      value: 0,
      type: "decimal",
      required: true,
    },
    {
      id: "note",
      paymentKey: "memo",
      label: "Note",
      placeholder: "Note",
      value: "",
      type: "textarea",
      required: false,
    },
    {
      id: "scheduledDate",
      paymentKey: "scheduledDate",
      label: "Transaction Date",
      placeholder: "",
      value: "",
      type: "readonly",
      required: false,
    },
    {
      id: "createdAt",
      paymentKey: "createdAt",
      label: "Data Entry Date",
      placeholder: "",
      value: "",
      type: "readonly",
      required: false,
    },
  ];
};

export default DefaultFormData;